import { useCallback, useEffect, useState } from "react";
import { api } from "./api";

export const useAthletes = () => {
  const [athletes, setAthletes] = useState([]);
  const load = useCallback(() => api.get("/athletes").then((r) => setAthletes(r.data)), []);
  useEffect(() => { load(); }, [load]);
  return [athletes, load];
};

export const useStages = () => {
  const [stages, setStages] = useState([]);
  useEffect(() => { api.get("/stages").then((r) => setStages(r.data)); }, []);
  return stages;
};

export const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const ta = document.createElement("textarea");
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  }
};
